import logo from './logo.svg';
import './App.css';

import React from "react";


const PrivacyPolicyPage = () => {
  return (
    <div style={styles.page}>
      <div style={styles.wrapper}>
        <div style={styles.headerCard}>
          <h1 style={styles.mainTitle}>Privacy Policy</h1>
          <p style={styles.updated}>Last updated: 21 January 2026</p>
        </div>

        <Card>
          <p style={styles.text}>
            This Privacy Policy explains how <strong>Mindscraft</strong>
            ("we", "our", or "us") collects, uses, discloses, and protects your information
            when you use our mobile application <strong>Paynet Softpos</strong>.
          </p>
        </Card>

        <Card title="1. Information We Collect">
          <SubTitle>Personal Information</SubTitle>
          <p style={styles.text}>
            We may collect personal information such as your name, phone number,
            email address, and identification details when required for verification
            or regulatory compliance.
          </p>

          <SubTitle>Financial & Transaction Information</SubTitle>
          <p style={styles.text}>
            Transaction details such as amount, date, and recipient are collected to
            process payments. Sensitive payment data is handled securely by certified
            third-party providers.
          </p>

          <SubTitle>Device & Technical Information</SubTitle>
          <p style={styles.text}>
            We may collect IP address, device information, crash logs, and usage data
            to improve performance, security, and reliability.
          </p>
        </Card>

        <Card title="2. How We Use Your Information">
          <p style={styles.text}>
            Your information is used to process transactions, prevent fraud, improve
            app functionality, send important updates, and comply with legal obligations.
          </p>
        </Card>

        <Card title="3. Data Sharing & Disclosure">
          <p style={styles.text}>
            We do not sell your data. Information may be shared with trusted service
            providers, legal authorities when required by law, or for fraud prevention.
          </p>
        </Card>

        <Card title="4. Data Security">
          <p style={styles.text}>
            We use encryption, secure authentication, and restricted access controls
            to protect your data against unauthorized access.
          </p>
        </Card>

        <Card title="5. Data Retention">
          <p style={styles.text}>
            Data is retained only as long as required for business, legal, or regulatory
            purposes and is securely deleted afterward.
          </p>
        </Card>

        <Card title="6. User Rights">
          <p style={styles.text}>
            You may request access, correction, or deletion of your personal data,
            subject to applicable laws.
          </p>
        </Card>

        <Card title="7. Children’s Privacy">
          <p style={styles.text}>
            Our app is not intended for children under the age of 13. We do not knowingly
            collect personal information from children.
          </p>
        </Card>

        <Card title="8. Third-Party Links">
          <p style={styles.text}>
            We may link to third-party services. We are not responsible for their
            privacy practices.
          </p>
        </Card>

        <Card title="9. Policy Updates">
          <p style={styles.text}>
            This policy may be updated periodically. Changes will be reflected in the app
            and the update date above.
          </p>
        </Card>

        <Card title="10. Contact Us">
          <p style={styles.text}><strong>Email:</strong> support@mindscrfat.pk</p>
          <p style={styles.text}><strong>Company:</strong> Mindscraft</p>
        </Card>
      </div>
    </div>
  );
};

/* ---------- Reusable Components ---------- */

const Card = ({ title, children }) => (
  <div style={styles.card}>
    {title && <h2 style={styles.cardTitle}>{title}</h2>}
    {children}
  </div>
);

const SubTitle = ({ children }) => (
  <h3 style={styles.subTitle}>{children}</h3>
);

/* ---------- Styles ---------- */

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f4f7fb, #e9eef5)",
    padding: "24px",
    fontFamily: "Inter, Arial, sans-serif",
  },
  wrapper: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  headerCard: {
    background: "#0f172a",
    color: "#ffffff",
    padding: "28px",
    borderRadius: "14px",
    marginBottom: "24px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  },
  mainTitle: {
    fontSize: "2.4rem",
    marginBottom: "6px",
  },
  updated: {
    fontSize: "0.9rem",
    opacity: 0.8,
  },
  card: {
    background: "#ffffff",
    borderRadius: "14px",
    padding: "22px",
    marginBottom: "20px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
  },
  cardTitle: {
    fontSize: "1.4rem",
    color: "#2563eb",
    marginBottom: "12px",
  },
  subTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    marginTop: "12px",
    marginBottom: "6px",
    color: "#0f172a",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.7rem",
    color: "#334155",
  },
};




function App() {
  return (
    <div className="App">
      {
        <PrivacyPolicyPage />
      }
    </div>
  );
}

export default App;
